<template>
  <div :class="responsiveClass" :style="containerStyle">
    <slot />
  </div>
</template>

<script>
export default {
  name: "Container",
  props: {
    padding: {
      type: [String, Number],
      default: 15,
    },
    margin: {
      type: [String, Number],
      default: "0 auto",
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    breakpoints: {
      type: Object,
      default: () => ({
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1440,
      }),
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    responsiveClass() {
      if (this.fullWidth) return "container-full";
      const { sm, md, lg, xl, xxl } = this.breakpoints;
      if (this.windowWidth >= xxl) return "container-xxl";
      if (this.windowWidth >= xl) return "container-xl";
      if (this.windowWidth >= lg) return "container-lg";
      if (this.windowWidth >= md) return "container-md";
      if (this.windowWidth >= sm) return "container-sm";
      return "";
    },
    containerStyle() {
      return {
        padding:
          typeof this.padding === "number" ? `${this.padding}px` : this.padding,
        margin:
          typeof this.margin === "number" ? `${this.margin}px` : this.margin,
        width: this.fullWidth ? "100%" : "auto",
      };
    },
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.container-sm {
  max-width: 540px;
  margin: 0 auto;
}

.container-md {
  max-width: 720px;
  margin: 0 auto;
}

.container-lg {
  max-width: 960px;
  margin: 0 auto;
}

.container-xl {
  max-width: 1200px;
  margin: 0 auto;
}

.container-xxl {
  max-width: 1440px;
  margin: 0 auto;
}

.container-full {
  width: 100%;
  margin: 0;
  padding: 0 15px;
}
</style>
